import { baseApi } from 'src/utils'
import { paths } from 'src/routes/paths'
import { STORAGE_KEY, AUTH_TYPE_KEY, AUTH_TYPE_MSAL } from 'src/constants'
import { encrypt, decrypt } from 'src/utils/storage'
import toast from 'react-hot-toast'
import i18n from 'src/locales'

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  )

  return JSON.parse(jsonPayload)
}

export const isValidToken = (encryptedToken: string) => {
  if (!encryptedToken) {
    return false
  }

  try {
    const decryptedToken = decrypt(encryptedToken)
    const decoded = jwtDecode(decryptedToken)

    if (!decoded || !decoded.exp) {
      return false
    }

    const currentTime = Date.now() / 1000
    return decoded.exp > currentTime
  } catch (error) {
    return false
  }
}

let expiredTimer: ReturnType<typeof setTimeout> | undefined

export const tokenExpired = (exp: number) => {
  // eslint-disable-next-line prefer-const
  const currentTime = Date.now()
  const timeLeft = exp * 1000 - currentTime

  clearTimeout(expiredTimer)

  expiredTimer = setTimeout(() => {
    toast.error(i18n.t('error.sessionExpired'))
    setSession(null)
    window.location.href = paths.auth.login
  }, timeLeft)
}

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    const authType = localStorage.getItem(AUTH_TYPE_KEY)

    if (authType !== AUTH_TYPE_MSAL) {
      localStorage.setItem(STORAGE_KEY, encrypt(accessToken))
    }

    baseApi.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

    if (authType !== AUTH_TYPE_MSAL) {
      const { exp } = jwtDecode(accessToken)
      tokenExpired(exp)
    }
  } else {
    const authType = localStorage.getItem(AUTH_TYPE_KEY)
    if (authType !== AUTH_TYPE_MSAL) {
      localStorage.removeItem(STORAGE_KEY)
    }
    delete baseApi.defaults.headers.common['Authorization']
  }
}
